module.exports = __webpack_public_path__ + "static/media/clancy-engineering.81322f23.jpg";